import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { h5PageCount } from 'ThreeTerminal_utils';
import { QQShare } from 'ThreeTerminal_mobile_dynamic';
import Header from './header';
import BigVideoNew from './bigVideoNew';
import RelateTitle from './relateTitle';
import RelateVideo from './relateVideoNew';
import OpenAppButton from './openAppButton';
import Logo from './logo';
import styles from './index.css';

class Layout extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    componentDidMount() {
        // 上报首屏时间
        if (window && window.BJ_REPORT) window.BJ_REPORT.firstScreen();
        const {
            content: {
                docData: { base62Id },
                isVideoShare,
            },
        } = this.props;

        // 手凤不发送page统计
        // if (isShare) {
        // 页面统计
        h5PageCount([
            {
                datatype: isVideoShare ? 'vappsns_ex' : 'newsappsns',
                behavior: 'page',
                type: 'sv',
                other: {
                    id: `sv_${base62Id}`,
                    ref: encodeURIComponent(document.referrer),
                    url: encodeURIComponent(location.href),
                },
            },
        ]);
        // }
    }

    render() {
        const {
            content: {
                isVideoShare,
                _id,
                headKeyword,
                commentUrl,
                docData,
                aspect,
                docData: { base62Id, subscribe, miniVideoPoster },
                videoInfo: { title, sharePosterUrl, bigPosterUrl, mobileUrl, guid, columnName, desc },
                readNumConfig,
                hasCopyRight,
                publishedTime,
                newsTime,
                searchPath,
                wemediaEAccountId,
                safeLevel,
                interact,
                isCloseAlgRec,
            },
        } = this.props;
        const headerData = {
            ...docData,
            isVideoShare,
            _id,
            headKeyword,
        };
        const qqShareCofig = {
            title,
            img: sharePosterUrl || 'https://p1.ifengimg.com/29b92e35b2b20708/2017/51/ifengLogo300x300.jpg',
            desc: '',
            appType: isVideoShare ? 'videoApp' : 'newsApp',
            cb: () => {},
        };
        const bigVideoData = {
            bigPosterUrl: miniVideoPoster || bigPosterUrl,
            mobileUrl,
            base62Id,
            isVideoShare,
            guid,
            _id,
            columnName,
            desc,
            logo: subscribe?.logo || '',
            subscribe,
            commentUrl,
            aspect,
            readNumConfig,
            hasCopyRight,
            publishedTime,
            newsTime,
            searchPath,
            wemediaEAccountId,
            safeLevel,
            interact,
            title,
        };
        const relateVideoData = {
            base62Id,
        };
        const openAppButtonData = {
            _id,
            isVideoShare,
            base62Id,
            interact,
        };

        const isHitBlack = safeLevel === 1;
        const isShowRelateVideo = !isHitBlack && !isCloseAlgRec;

        return (
            <div className={styles.layout}>
                <Header content={headerData} />
                <BigVideoNew content={bigVideoData} />
                {isShowRelateVideo && <RelateTitle content={openAppButtonData} />}
                {isShowRelateVideo && <RelateVideo content={relateVideoData} />}
                <Logo content={openAppButtonData} />
                <OpenAppButton content={openAppButtonData} />

                {qqShareCofig.title && <QQShare content={qqShareCofig} />}
            </div>
        );
    }
}

export default errorBoundary(Layout);
